import _ from 'underscore';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import entityComposition from '../../common/classes/entityComposition';
import entityDropdownButtonFactory from '../../common/lookups/entityDropdownButtonFactory';
import DryFilmItem from './contractSpecDryFilmItem';
import SegmentedPicker from '../../common/controls/segmentedPicker';
const CoatTypeDropdown = entityDropdownButtonFactory('coatType');
class ContractSpecDryFilm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      thicknessUnits: 0
    }; // default thicknessUnits is 0

    this.handleAdd = this.handleAdd.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleThickUnitChange = this.handleThickUnitChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      coatTypeActions = _this$props.coatTypeActions,
      coatType = _this$props.coatType;
    coatTypeActions.serverIndex(coatType.indexQuery);
  }
  handleChange(index, name, value) {
    const onChange = this.props.onChange;
    onChange("dryFilms[".concat(index, "]/").concat(name), value);
  }
  handleRemove(index) {
    const _this$props2 = this.props,
      onChange = _this$props2.onChange,
      active = _this$props2.active;
    const dryFilms = JSON.parse(JSON.stringify(active.dryFilms));
    dryFilms.splice(index, 1);
    onChange('dryFilms', dryFilms);
  }
  handleAdd(coatType) {
    const _this$props3 = this.props,
      userID = _this$props3.userID,
      active = _this$props3.active,
      onChange = _this$props3.onChange;
    const thicknessUnits = this.state.thicknessUnits;

    // create a new dry film and add it to the array of existing dryFilms
    const newDryFilm = {
      id: uuidV4().toUpperCase(),
      appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      appCreatorID: userID,
      contractSpecID: active.id,
      thicknessUnits,
      coatTypeID: coatType.id
    };
    const dryFilms = active.dryFilms;
    dryFilms.push(newDryFilm);
    onChange('dryFilms', dryFilms);
  }

  // updates the thicknessUnits to reflect changes in the toggle switch
  handleThickUnitChange(newThickness) {
    const _this$props4 = this.props,
      dryFilms = _this$props4.active.dryFilms,
      onChange = _this$props4.onChange;
    // modify dryFilm entities with new thicknessUnit
    if (dryFilms.length) {
      dryFilms.forEach(dryFilm => {
        const df = dryFilm;
        df.thicknessUnits = newThickness;
      });
    }
    onChange('dryFilms', dryFilms);
    this.setState({
      thicknessUnits: newThickness
    });
  }
  render() {
    const _this$props5 = this.props,
      dryFilms = _this$props5.active.dryFilms,
      coatType = _this$props5.coatType;
    const thicknessUnits = this.state.thicknessUnits;
    let stateThicknessUnits = thicknessUnits;
    // if dryFilms already have a thicknessUnit, change default value
    if (dryFilms && dryFilms.length > 0) {
      if (dryFilms[0].thicknessUnits !== stateThicknessUnits) {
        stateThicknessUnits = dryFilms[0].thicknessUnits;
      }
    }

    // Grabs the id of the coat type that is stored
    const coatTypes = _.pluck(dryFilms, 'coatTypeID');
    const dryFilmItems = _.map(dryFilms, (nextDryFilm, dryFilmIndex) => /*#__PURE__*/React.createElement(DryFilmItem, {
      active: nextDryFilm,
      coatTypeList: coatType.list,
      index: dryFilmIndex,
      key: nextDryFilm.id,
      onChange: this.handleChange,
      onRemove: this.handleRemove,
      thicknessUnits: stateThicknessUnits
    }));
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Dry Film Thickness"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      names: ['Mils', 'Microns'],
      values: [0, 1],
      label: "Thickness Units",
      allowNull: false,
      onChange: this.handleThickUnitChange,
      value: stateThicknessUnits
    }))), /*#__PURE__*/React.createElement("div", null, dryFilmItems), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(CoatTypeDropdown, {
      entity: "CoatType",
      enforceUnique: true,
      list: coatType.list,
      onAdd: this.handleAdd,
      title: "Add Coat",
      values: coatTypes
    }))));
  }
}
ContractSpecDryFilm.propTypes = {
  active: PropTypes.shape({
    id: PropTypes.string,
    dryFilms: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      thicknessUnits: PropTypes.number
    }))
  }).isRequired,
  coatType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  coatTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  userID: PropTypes.string.isRequired
};
export { ContractSpecDryFilm as TestContractSpecDryFilm };
export default entityComposition(ContractSpecDryFilm, ['coatType'], {});